import environmentBase from './base';
import { PublicConf } from './public-conf.models';

export const environment = Object.assign(environmentBase.public, {
	production: true,
	name: 'prod',
	deployUrl: 'https://tmt-claim-portal-bo.aonaqua.io',
	security: {
		enabled: true, // Can be used to disable all security checks (login, guards ...)
		url: 'https://auth.aonaqua.io/auth', // Url of the identity provider
		realm: 'aon-production', // To be set when using keycloak
		clientId: 'urn:aon:client:aqua-tmt-claim-portal-bo', // Client Id of you app
		provider: 'keycloak', // Identity Provider to use, only keycloak available for now
		redirectionPath: '/timers', // Redirect path if the user have not the right role
	}
} as PublicConf);
